/**
 * Снимает техническую внешнюю <div> без атрибутов (обёртка CKEditor).
 * Семантические div с class/style не трогаем.
 */
export function unwrapSingleOuterDiv (html) {
  if (!html || typeof html !== 'string') return html || ''

  const template = document.createElement('template')
  template.innerHTML = html.trim()

  let root = template.content.firstElementChild
  const hasSingleRoot = template.content.childElementCount === 1 && root

  if (!hasSingleRoot) return html

  const isPlainWrapperDiv = (el) => {
    return (
      el &&
      el.tagName?.toLowerCase() === 'div' &&
      el.attributes.length === 0
    )
  }

  while (
    isPlainWrapperDiv(root) &&
    root.children.length === 1 &&
    isPlainWrapperDiv(root.firstElementChild)
  ) {
    root = root.firstElementChild
  }

  if (!isPlainWrapperDiv(root)) return html
  return root.innerHTML
}

/** Разворачивает виджеты CKEditor HTML-вставки: <div class="raw-html-embed"> → содержимое */
export function unwrapRawHtmlEmbedWidgets (html) {
  if (!html || typeof html !== 'string') return html || ''

  const container = document.createElement('div')
  container.innerHTML = html

  container.querySelectorAll('.raw-html-embed').forEach((el) => {
    const fragment = document.createDocumentFragment()
    while (el.firstChild) {
      fragment.appendChild(el.firstChild)
    }
    el.replaceWith(fragment)
  })

  return container.innerHTML
}

/** Убирает пустые абзацы с &nbsp; (часто остаются вокруг embed) */
export function removeEmptyNbspParagraphs (html) {
  if (!html || typeof html !== 'string') return html || ''
  return html.replace(/<p>(?:\s|&nbsp;|\u00a0)*<\/p>/gi, '')
}

/** Полная очистка HTML из редактора перед сохранением */
export function sanitizeEditorHtml (html) {
  if (!html || typeof html !== 'string') return html || ''
  let result = unwrapRawHtmlEmbedWidgets(html)
  result = removeEmptyNbspParagraphs(result)
  result = unwrapSingleOuterDiv(result)
  return result.trim()
}

const EDITOR_HTML_FIELDS = ['Header', 'Synopsis', 'Description', 'Characteristics']

/** Очистка полей формы и контент-блоков HyperText */
export function unwrapFormEditorHtml (form, fields = EDITOR_HTML_FIELDS) {
  if (!form || typeof form !== 'object') return form

  const result = { ...form }

  fields.forEach((key) => {
    if (typeof result[key] === 'string' && result[key]) {
      result[key] = sanitizeEditorHtml(result[key])
    }
  })

  if (Array.isArray(result.ContentBlocks)) {
    result.ContentBlocks = result.ContentBlocks.map((block) => {
      if (block?.Type === 'HyperText' && typeof block.Text === 'string' && block.Text) {
        return { ...block, Text: sanitizeEditorHtml(block.Text) }
      }
      return block
    })
  }

  return result
}
